import React from 'react';
import {v4 as uuid} from 'uuid';
import Field from "./../field";
import Grid from '@material-ui/core/Grid';
import Button from "@material-ui/core/Button";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import IconButton from "@material-ui/core/IconButton";
import Close from '@material-ui/icons/Close';
import {compose} from "redux";
import {withStyles} from "@material-ui/core";
import {styles} from "../../../styles/documents";
import {withTranslation} from "react-i18next";

class FieldNestedMultipleEntities extends React.Component {
    constructor(props) {
        super(props);
        this.addNestedMultipleEntities = this.addNestedMultipleEntities.bind(this);
        this.removeNestedMultipleEntities = this.removeNestedMultipleEntities.bind(this);
        const {defaultValue} = this.props;
        this.state = {
            nestedMultipleEntitiesList: defaultValue
                ? defaultValue.map(subject => {return {...subject, uuid: uuid()}})
                : [],
        };
    }
    addNestedMultipleEntities() {
        const {nestedMultipleEntitiesList} = this.state;
        this.setState({nestedMultipleEntitiesList: [...nestedMultipleEntitiesList, {uuid: uuid()}]});
    }
    removeNestedMultipleEntities(uuid) {
        const {nestedMultipleEntitiesList} = this.state;
        const filteredNestedMultipleEntitiesList = nestedMultipleEntitiesList.filter((nestedMultipleEntitiesRow) => {
            return nestedMultipleEntitiesRow.uuid !== uuid;
        });
        this.setState({nestedMultipleEntitiesList: filteredNestedMultipleEntitiesList});
    }
    render() {
        const { classes } = this.props;
        const {name, scheme, refs, i18n, t} = this.props;
        const {nestedMultipleEntitiesList} = this.state;
        const {addNestedMultipleEntities, removeNestedMultipleEntities} = this;
        refs[name] = [];
        const isLabelEn = i18n.language === 'en' && scheme.label_en

        return (
            <Grid container spacing={1}>
                <Grid item xs={12}>
                    <label>
                        {isLabelEn ? scheme.label_en: scheme.label}
                        {scheme.required === true ? <span className="MuiFormLabel-asterisk">*</span> : ''}
                    </label>
                </Grid>
                <Grid item xs={12}>
                    <TableContainer component={Paper}>
                        <Table size="small" aria-label="sub table">
                            <TableHead>
                                <TableRow>
                                    <TableCell>№</TableCell>
                                    {Object.keys(scheme.type.element_fields).map((elementField, numElementField) => {
                                        const label =
                                            i18n.language === 'en' && scheme.type.element_fields[elementField].label_en
                                                ? scheme.type.element_fields[elementField].label_en
                                                : scheme.type.element_fields[elementField].label
                                        return (
                                            <TableCell key={numElementField}>
                                                {label}
                                                {scheme.type.element_fields[elementField].required === true ? <span className="MuiFormLabel-asterisk">*</span> : null}
                                            </TableCell>
                                        )
                                    })}
                                    <TableCell align="right"/>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {nestedMultipleEntitiesList.map((nestedMultipleEntitiesRow, numNestedMultipleEntitiesRow) => {
                                    refs[name][numNestedMultipleEntitiesRow] = {};
                                    return (
                                        <TableRow key={nestedMultipleEntitiesRow.uuid}>
                                            <TableCell>{numNestedMultipleEntitiesRow + 1}</TableCell>
                                            {Object.keys(scheme.type.element_fields).map((elementField, numElementField) => {
                                                return (
                                                    <TableCell key={numElementField}>
                                                        <Field
                                                            name={elementField}
                                                            scheme={scheme.type.element_fields[elementField]}
                                                            defaultValue={nestedMultipleEntitiesRow[elementField]}
                                                            refs={refs[name][numNestedMultipleEntitiesRow]}
                                                            isLabel={false} />
                                                    </TableCell>
                                                )
                                            })}
                                            <TableCell className={classes.alignRight}>
                                                <IconButton aria-label="delete" color="secondary" size="small" onClick={() => removeNestedMultipleEntities(nestedMultipleEntitiesRow.uuid)}>
                                                    <Close />
                                                </IconButton>
                                            </TableCell>
                                        </TableRow>
                                    );
                                })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Grid>
                <Grid item xs={12}>
                    <Button variant="outlined" size="small" onClick={addNestedMultipleEntities}>{t('add')}</Button>
                </Grid>
            </Grid>
        );
    }
}
export default compose(withStyles(styles))(withTranslation()(FieldNestedMultipleEntities));